export default __webpack_public_path__ + "asset/img/svg/coins~01f92e0c.svg";